export const DEFAULT_TEMPLATE_WCA_STATE = {
  loading: false,
  templateList: [],
  totalTemplatesCount: 0,
  selectedTemplate: null,
  pageNo: 0,
  limit: 30,
  templateMode: 'create',
  templateFormModule: false,
  selectcampaignType: null,
  templateLibraryList: [],
  templateLibraryCursor: null,
  templateLibraryLoading: false,
  templateLibraryError: null,
};
